<template>
  <div class="container">
    <div class="login-container">
      <div class="title">
        <span style="font-size:18px;color:#606266">五格殿下</span><br>
        <span style="font-size:14px;color:#909399">少儿编程解决方案服务商</span>
        
        </div>
      <div>
        <el-form ref="form" :model="form" label-width="0px">
          <el-form-item >
            <el-input
            
              v-model="form.username"
              placeholder="请输入手机号"
            >
            <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item >
            <el-input
              placeholder="请输入密码"
              v-model="form.password"
              show-password
            >
             <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center;">
          <el-button type="primary" @click="onSubmit" style="width: 100%;background:#304163;"
            >登 录</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    onSubmit() {
      this.$store.dispatch("LoginByAdminUsername", this.form).then(() => {
        this.$router.push({ name: "admin-index" });
      });
    },
  },
};
</script>

<style scoped>
.container {
  background-color: #304163;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

}
.container .login-container {
  width: 450px;
  height: 300px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 20px 20px 20px;

  
}
.container .login-container .title {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  padding: 20px 0;
}
</style>
